import { useCountries, countryOf } from "@/components/Country";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { STATUS } from "@/components/townStatus";

const PIN = new Set(["built", "published"]);

export const TownMap = ({ towns, country }) => {
  const list = useCountries();
  const c = countryOf(list, country);
  const pal = (t) => countryOf(list, t.country)?.palette || { dark: "#3B1B48", accent: "#C59B27" };
  const placed = towns.filter((t) => t.lat != null);
  const dots = placed.filter((t) => !PIN.has(t.status));
  const pins = placed.filter((t) => PIN.has(t.status));
  return (
    <div data-testid="town-map" className="relative border border-[#E2D9CC] h-[560px] bg-[#FAF7F2]">
      <MapContainer key={`${country || "all"}-${list.length}`} {...(country && c ? { bounds: c.bounds } : list.length > 1 ? { bounds: [[Math.min(...list.map((x) => x.bounds[0][0])), Math.min(...list.map((x) => x.bounds[0][1]))], [Math.max(...list.map((x) => x.bounds[1][0])), Math.max(...list.map((x) => x.bounds[1][1]))]] } : { center: [42.6, 12.5], zoom: 6 })} zoomSnap={0.25} preferCanvas scrollWheelZoom={false} className="h-full w-full">
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" maxZoom={18} className="town-map-tiles" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        {dots.map((t) => (
          <CircleMarker key={t.id} center={[t.lat, t.lng]} radius={3} pathOptions={{ color: "#8C827A", weight: 0, fillColor: t.status === "building" || t.status === "queued" ? "#B45309" : "#8C827A", fillOpacity: 0.55 }}>
            <Popup><p className="font-display text-base text-[#3B1B48] m-0">{t.town}</p><p className="text-xs text-[#8C827A] m-0">{t.province ? `${t.province}, ` : ""}{t.region} · {STATUS[t.status]?.label}</p></Popup>
          </CircleMarker>
        ))}
        {pins.map((t) => (
          <CircleMarker key={t.id} center={[t.lat, t.lng]} radius={9} pathOptions={{ color: pal(t).dark, weight: 2, fillColor: pal(t).accent, fillOpacity: 0.95 }}>
            <Popup>
              <p className="text-[10px] uppercase tracking-widest text-[#C59B27] m-0">No. {t.issue_number} · {STATUS[t.status].label}</p>
              <p className="font-display text-lg text-[#3B1B48] my-1">{t.town}</p>
              <Link to={`/guides/${t.guide_id}`} className="text-xs text-[#3B1B48] underline">Open the guide</Link>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
      <div className="absolute bottom-3 left-3 z-[400] bg-white/90 backdrop-blur px-3 py-2 text-xs text-[#1C181D] flex gap-4 border border-[#E2D9CC]" data-testid="town-map-legend">
        <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded-full bg-[#C59B27] border-2 border-[#3B1B48] inline-block" />Guide available ({pins.length})</span>
        <span className="flex items-center gap-1.5"><i className="w-2 h-2 rounded-full bg-[#B45309] inline-block" />Building</span>
        <span className="flex items-center gap-1.5"><i className="w-2 h-2 rounded-full bg-[#8C827A] inline-block" />Not yet</span>
      </div>
    </div>
  );
};
